import styled from "styled-components";

export const TransparentContainer = styled.div`
  width: 100vh;
  height: 100vw;
  background-color: red;
`;

export const Content = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MainContainer = styled.div`
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const TitleContainer = styled.div`
  width: 100%;
  height: 70px;
  background-color: #104467;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    color: white;
    font-weight: 600;
    font-size: 1.4rem;
  }
`;

export const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const TextImageContainer = styled.div`
  width: 100%;
  height: 70%;
  background-color: #edf1f6;
  padding: 0 10%;
  display: flex;

  @media (max-width: 1400px) {
    padding: 0 2%;
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    padding: 20px 5%;
    height: fit-content;
  }
`;

export const TextContainer = styled.div`
  width: 55%;
  height: 100%;
  display: flex;
  align-items: center;

  p {
    color: black;
    overflow: auto;
    font-size: 1.25rem;
    text-align: justify;
  }

  @media (max-width: 1000px) {
    width: auto;
    height: 50%;
  }
`;

export const ImageContainer = styled.div`
  flex: 1;
  margin: 20px;
  position: relative;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }

  @media (max-width: 1000px) {
    width: auto;
    height: fit-content;
  }
`;

export const InfoTicoopContainer = styled.div`
  flex: 1;
  background-color: #104467;
  padding: 0 10%;
  min-height: 150px;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    color: white;
    overflow: auto;
    font-size: 1.3rem;
    text-align: center;
  }

  @media (max-width: 1400px) {
    padding: 0 2%;
  }

  @media (max-width: 1000px) {
    padding: 20px 5%;

    p {
      font-size: 1.2rem;
    }
  }
`;

export const LoginInputContainer = styled.div`
  width: 100%;
  padding: 20px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #edf1f6;
`;

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

export const Form = styled.form`
  margin-top: 20px;
  display: flex;
  flex-direction: column;

  label {
    font-size: 0.8rem;
    margin-bottom: 3px;
    color: #104467;
  }

  input {
    margin-bottom: 20px;
    height: 40px;
    padding: 0 10px;
    border-radius: 4px;
    border: 1px solid rgba(16, 68, 103, 0.34);
  }

  .erro {
    color: red;
    margin: 10px 0;
    display: flex;
    justify-content: center;
    font-size: 15px;
    align-self: start;
  }
`;

export const ForgetPasswordContainer = styled.div`
  margin-bottom: 20px;
  display: flex;
  width: 100%;
`;

export const ForgetPassword = styled.span`
  font-size: 0.75rem;
  cursor: pointer;
`;

export const RegisterButton = styled.button`
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: #104467;
`;

export const LoginContainer = styled.div`
  width: 100%;
  height: 130px;
  background-color: #ffffff;
`;

export const RowItems = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: fit-content;
  margin: 0 auto;
  justify-content: space-evenly;

  span {
    color: black;
    font-weight: 400;
    font-size: 1rem;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Button = styled.div`
  font-family: "Montserrat", Sans-serif;
  padding: 10px 20px;
  border: none;
  width: 150px;
  border-radius: 10px;
  background-color: #104467;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
    transform: scale(1.05);
    transition: ease-in-out 0.15s;
  }
`;

export const LoginButton = styled.button`
  background: #104467;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  padding: 10px;
  margin: 3px;
  color: white;

  &:hover {
    background: rgb(9, 41, 61);
  }

  &:disabled {
    background-color: rgb(160, 160, 160);
    cursor: not-allowed;
  }
`;
